import React from 'react';
import {
  Link
} from "react-router-dom";

export function NewPage ({...props}) {
    return (
        <Link onClick={()=>window.scroll(0,0)} {...props} />
    )
  };


